<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <a href="javascript:void(0)">Registers</a>
                    </li>
                    <li class="breadcrumb-item" aria-current="page">
                        <router-link to="/user_services">Inward Spares</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page" v-if="status">New Inward Spare</li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>Update Inward Spare</li>
                </ol>
                <h4 class="main-title mb-0">Inward Spare</h4>
            </div>
            <router-link to="/inward_spares" type="submit" class="btn btn-primary" style="float: right;"><i class="ri-list-check"></i> INWARD SPARES</router-link>
        </div>
        <div class="row">
            <div class="col-12" v-can="'service_registers.create'">
                <form @submit.prevent="submitForm">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Inward Spare</h6>
                            <h6 class="card-title" v-else>Update Inward Spare</h6>
                            <div class="col-md-4">
                                    <!-- <label class="form-label">Reference Date</label><span class="text-danger"> *</span> -->
                                    <input
                                        type="datetime-local"
                                        class="form-control"
                                        placeholder="Enter Reference Date"
                                        :class="{'is-invalid': errors?.reference_date}"
                                        :value="convertDateFormat(user_service.reference_date)"
                                        v-model="user_service.reference_date"
                                        ref="reference_date"
                                        :disabled=!status
                                    />
                                    <span v-if="errors?.reference_date" class="invalid-feedback">{{ errors?.reference_date[0] }}</span>
                                </div>
                        </div>
                        <div class="card-body">
                            <div class="row g-2 mb-5">
                                <div class="col-md-12">
                                    <label class="form-label">Note</label>
                                    <textarea type="text" placeholder="Enter Note" class="form-control" :class="{'is-invalid': errors?.note}" v-model="user_service.note"></textarea>
                                    <span v-if="errors?.note" class="invalid-feedback">{{ errors?.note[0] }}</span>
                                </div>
                            </div>

                            <div class="row g-2">
                                <div class="">
                                    <table class="table table-responsive table-responsive-sm table-sm text-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th>Spare <span class="text-danger"> *</span></th>
                                                <th>Quantity <span class="text-danger"> *</span></th>
                                                <th>Unit Cost <span class="text-danger"> *</span></th>
                                                <th>Total Cost<span class="text-danger"> *</span></th>
                                                <th class="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <search
                                                        :class="{ 'is-invalid': errors?.spare_id }"
                                                        :customClass="{ 'is-invalid': errors?.spare_id }"
                                                        aria-describedby="basic-addon2"
                                                        aria-label="Select Spare"
                                                        :initialize="user_spare.spare_id"
                                                        id="spare_id"
                                                        label="spare_name"
                                                        label2="spare_code"
                                                        placeholder="Select Spare"
                                                        :data="spares"
                                                        @input=" spare1 => user_spare.spare_id = spare1"
                                                        @selectsearch="getValue(user_spare.spare_id)"
                                                    >
                                                    </search>
                                                    <span v-if="errors?.spare_id" class="invalid-feedback">{{ errors?.spare_id[0] }}</span>
                                                </td>
                                                <td>
                                                    <input type="number" step="any" class="form-control" placeholder="Enter Quantity" min="0" :class="{ 'is-invalid': errors?.quantity }" v-model="user_spare.quantity" @input="calculateTotal"/>
                                                    <span v-if="errors?.quantity" class="invalid-feedback">{{ errors?.quantity[0] }}</span>
                                                </td>
                                                <td>
                                                    <input type="number" step="any"  class="form-control" placeholder="Enter Unit Cost" min="0" :class="{ 'is-invalid': errors?.spare_cost }" v-model="user_spare.spare_cost" @input="calculateTotal"/>
                                                    <span v-if="errors?.spare_cost" class="invalid-feedback">{{ errors?.spare_cost[0] }}</span>
                                                </td>
                                                <td>
                                                    <input type="number" step="any"  class="form-control" min="0" :class="{ 'is-invalid': errors?.spare_cost }"   :value="user_spare.total" disabled/>
                                                    <span v-if="errors?.total" class="invalid-feedback">{{ errors?.total[0] }}</span>
                                                </td>
                                                <td class="text-center">
                                                    <button v-if="user_spare.status" class="btn btn-outline-success mx-1" @click.prevent="addRow()"><i class="ri-add-line fs-18 lh-1"></i></button>
                                                    <button v-else class="btn btn-outline-success mx-1" @click.prevent="updateRow(user_spare)"><i class="ri-save-line fs-18 lh-1"></i></button>
                                                    <button class="btn btn-outline-danger mx-1" @click.prevent="discardNewRow()"><i class="ri-close-line fs-18 lh-1"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr v-for="spare, index in user_service.user_spares" :key="index">
                                                <td>{{ spare?.spare?.spare_name }}</td>
                                                <td>{{ spare?.quantity }}</td>
                                                <td>{{ spare?.spare_cost }}</td>
                                                <td>{{ spare?.total }}</td>
                                                <td class="text-center">
                                                    <button type="button" class="btn btn-outline-primary mx-2" @click.prevent="editSpare(spare,index)"><i class="ri-pencil-line fs-18 lh-1"></i></button>
                                                    <button type="button" class="btn btn-outline-danger" @click.prevent="deleteSpare(spare,index)"><i class="ri-delete-bin-line fs-18 lh-1"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="text-center">
                                        <span v-if="errors.user_spares" class="invalid-feedback d-block">{{ errors.user_spares[0] }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <router-link type="button" to="/user_services" class="btn btn-danger me-2"><i class="ri-arrow-left-line fs-18 lh-1"></i> Back</router-link>
                            <button type="submit" class="btn btn-primary">
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Search from "@/components/Search.vue";
import AssetSearch from "@/components/AssetSearch.vue";
    import moment from "moment";
    export default {
        name: "Assets.Create",
        components: { Search,AssetSearch },
        data() {
            return {
                user_service: {
                    inward_id: "",
                    reference_no: "",
                    reference_date: "",
                    note: "",
                    user_spares: [],
                    deleted_user_spares: [],
                    status: true,
                },
                user_spare: {
                    inward_spare_id: "",
                    spare_id: "",
                    spare: {
                        spare_name: "",
                    },
                    spare_cost: "",
                    quantity:"",
                    total:"",
                    status: true,
                },
                deleted_spares: [],
                assets: [],
                services: [],
                spares: [],
                errors: [],
                status: true,
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (to.name == "InwardSpares.Create") {
                    vm.getSpares();
                    vm.$refs.reference_date.focus();
                } else {
                    vm.getSpares();
                    vm.status = false;
                    let uri = { uri: "getInwardSpare", data: { inward_id: to.params.inward_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.user_service = response.data.data;
                            console.log("USer-service--",vm.user_service)
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },
        mounted() {
            this.user_service.reference_date = moment().format("YYYY-MM-DD HH:mm");
        },
        methods: {
            calculateTotal() {
                const qty = parseFloat(this.user_spare.quantity) || 0;
                const cost = parseFloat(this.user_spare.spare_cost) || 0;
                this.user_spare.total = qty * cost;
            },
            convertDateFormat(date) {
                let vm = this;
                return moment(date).format("YYYY-MM-DD HH:mm");
            },
            submitForm() {
                let vm = this;
                vm.errors = [];
                if (vm.user_service.user_spares.length === 0) {
                    vm.errors.user_spares = ["At least one spare is required."];
                    vm.$store.dispatch("error", "Please add at least one spare before submitting.");
                    return;
                }
                if (vm.status) {
                    vm.addUserService();
                } else {
                    vm.updateUserService();
                }
            },
            getValue(value) {
                let vm = this;
                let spare = vm.spares?.filter(function (ele) {
                    return ele.spare_id == value;
                });
                if (spare.length) {
                    vm.user_spare.spare.spare_name = spare[0].spare_name;
                }
            },
            getSpares() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getAllSpares" })
                    .then((response) => {
                        loader.hide();
                        vm.spares = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            addUserService() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addInwardSpare", data: vm.user_service })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/inward_spares");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            updateUserService() {
                let vm = this;
                vm.user_service.deleted_user_spares = vm.deleted_spares;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateInwardSpare", data: vm.user_service })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.$router.push("/inward_spares");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            addRow() {
                let vm = this;
                vm.errors = {};
                if (vm.user_spare.spare_id == "" || vm.user_spare.spare_cost == "" || vm.user_spare.quantity == "") {
                    if (vm.user_spare.spare_id == "") {
                        vm.errors.spare_id = ["Spare field cannot be empty"];
                    }
                    if (vm.user_spare.spare_cost === null || vm.user_spare.spare_cost === undefined || vm.user_spare.spare_cost === "") {
                        vm.errors.spare_cost = ["Unit Cost cannot be empty"];
                    }
                    if (vm.user_spare.quantity === null || vm.user_spare.quantity === undefined || vm.user_spare.quantity === "") {
                        vm.errors.quantity = ["Quantity cannot be empty"];
                    }
                } else {

                    vm.user_service.user_spares.push({
                        inward_spare_id: "",
                        spare_id: vm.user_spare.spare_id,
                        spare: {
                            spare_name: vm.user_spare.spare.spare_name,
                        },
                        spare_cost: vm.user_spare.spare_cost,
                        quantity : vm.user_spare.quantity,
                        total : vm.user_spare.total
                    });
                    vm.discardNewRow();
                }
            },
            discardNewRow() {
                let vm = this;
                vm.user_spare.inward_spare_id = "";
                vm.user_spare.spare_id = "";
                vm.user_spare.spare_cost = "";
                vm.user_spare.quantity= "";
                vm.user_spare.total= "";
                vm.user_spare.spare.spare_name = "";
                vm.user_spare.status = true;
                vm.errors = [];
            },
            editSpare(spare, key) {
                let vm = this;
                vm.user_spare.inward_spare_id = spare.inward_spare_id;
                vm.user_spare.spare_id = spare.spare_id;
                vm.user_spare.spare.spare_name = spare.spare.spare_name;
                vm.user_spare.spare_cost = spare.spare_cost;
                vm.user_spare.quantity = spare.quantity;
                vm.user_spare.total = spare.total;
                vm.user_spare.status = false;
                vm.user_spare.key = key;
                vm.errors = [];
            },
            updateRow(spare) {
                let vm = this;
                vm.errors = {};
                if (vm.user_spare.spare_id == "" || vm.user_spare.spare_cost == "" || vm.user_spare.quantity == "") {
                    if (vm.user_spare.spare_id == "") {
                        vm.errors.spare_id = ["Spare field cannot be empty"];
                    }
                    if (vm.user_spare.spare_cost === null || vm.user_spare.spare_cost === undefined || vm.user_spare.spare_cost === "") {
                        vm.errors.spare_cost = ["Unit Cost cannot be empty"];
                    }
                    if (vm.user_spare.quantity === null || vm.user_spare.quantity === undefined || vm.user_spare.quantity === "") {
                        vm.errors.quantity = ["Quantity cannot be empty"];
                    }
                } else {
                    let spare_data = vm.user_service.user_spares.filter(function (element) {
                        return element.key == spare.key;
                    });
                    vm.user_service.user_spares[spare_data.key] = spare_data;
                    vm.user_service.user_spares.splice(vm.user_spare.key, 1);
                    vm.user_service.user_spares.push({
                        inward_spare_id: vm.user_spare.inward_spare_id,
                        spare_id: vm.user_spare.spare_id,
                        spare: {
                            spare_name: vm.user_spare.spare.spare_name,
                        },
                        spare_cost: vm.user_spare.spare_cost,
                        quantity: vm.user_spare.quantity,
                        total: vm.user_spare.total,
                    });
                    vm.discardNewRow();
                }
            },
            deleteSpare(spare, key) {
                let vm = this;
                if (confirm("Are you sure you want to delete")) {
                    vm.deleted_spares.push(spare?.inward_spare_id);
                    vm.user_service.user_spares.splice(key, 1);
                    vm.discardNewRow();
                }
            },
        },
    };
</script>
<style scoped>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
